import { format } from 'd3-format';
import PriceCoordinate from './lib/reference-price-line/PriceCoordinate';
import React from 'react';
import { THEMES } from '../../../configs/LayoutConfig';

const fillColorCf = {
  Dark: '#ffc859',
  Light: '#facc5c',
  Classic: '#ffc859',
};
const ChartPriceCoordinate = function({ price, theme, dx }) {
  const fillColor = fillColorCf[theme];
  return (
    <PriceCoordinate
      at="right"
      orient="right"
      price={price}
      stroke="#ffc859"
      dx={dx}
      fill={fillColor}
      strokeWidth={1}
      textFill="#2a2d34"
      lineStroke="#facc5c"
      lineOpacity={1}
      fontSize={12}
      snapX={false}
      displayFormat={format('.2f')}
      rectRadius={4}
      rectWidth={40}
      rectHeight={18}
    />
  );
};

ChartPriceCoordinate.defaultProps = {
  dx: 2,
};

export default ChartPriceCoordinate;
